import React from "react";
import * as styles from "./PreguntasFrecuentasCafetera.module.scss";
import { PreguntasFrecuentes } from "../../PreguntasFrecuentes/PreguntasFrecuentes";
import Footer from "../../UI/Footer/Footer";
import FooterMobile from "../../UI/Footer/FooterMobile";

const PreguntasFrecuentasCafetera = ({paises, categories, patternCategory, childCategory}) => {
  const faqDataExample = [
    {
      title: "¿Qué cápsulas pueden utilizarse?",
      description: "¡Esta cafetera es apta para cápsulas tipo Nespresso!",
    },
    {
      title: "¿Cómo se activa el precalentado de tazas?",
      description: "¡Es automático! Podes colocar tu taza en la parte superior de la cafetera e irá calentándose sola.",
    },
    {
      title: "Mantenimiento de la cafetera",
      description: "Debido a los minerales que se encuentran en el agua, es importante que se realice una limpieza periódica de la cafetera para evitar la acumulación de sarro. Recomendamos seguir los pasos de la limpieza que indica el manual cada 15/30 días para asegurar el buen gusto del café.",
    },
    {
      title: "¿Qué tipo de molienda de café se recomienda?",
      description: "El grado de molienda recomendado para nuestras cafeteras express es molienda media.",
    },
    {
      title: "¿Este modelo es apto para cápsulas?",
      description: "Los modelos aptos para cápsulas son PE-CE5003R-N / PE-CE5003N-N.",
    },
    {
      title: "¿Este modelo es igual al PE-CE5003R?",
      description: "No, este modelo cuenta con adaptador para cápsulas, más capacidad (1,25L), más potencia (1100w) y viene en color rojo y negro.",
    },
    {
      title: "Recomendaciones antes del primer uso",
      description: "Recordá que antes del primer uso se deben seguir los pasos indicados en la etiqueta roja del costado para activar y limpiar el circuito interno de la cafetera.",
    },
    {
      title: "¿Cómo se activa la función para mantener caliente el café?",
      description: "La función mantener caliente no se activa, es automática. Mientras la cafetera esté encendida y la jarra apoyada en la base, seguirá calentando el café. En los modelos PE-CT4207 y PE-MK01, mientras la cafetera se mantenga enchufada, mantendrá el café caliente durante 40 min.",
    },
    {
      title: "¿Cuáles son las cantidades recomendadas para cada función del espumador de leche PE-MF2316?",
      description: "Para espumar la cantidad máxima es de 150 ml. Para calentar la cantidad máxima es de 250 ml. Para calentar y espumar la cantidad máxima es de 250 ml.",
    },
  ];
  

  return (
    <section className={styles.container_section}>
      <div className={styles.container_preguntas}>
        <PreguntasFrecuentes faqData={faqDataExample} />
      </div>

      <div className={styles.container_footer}>
      <Footer
        paises={paises}
        categories={categories}
        patternCategory={patternCategory}
        childCategory={childCategory}
      />
      <FooterMobile
        paises={paises}
        patternCategory={patternCategory}
        childCategory={childCategory}
      />
      </div>
    </section>
  );
};

export default PreguntasFrecuentasCafetera;
